import React from 'react'

import Text from '@hixme-ui/text'
import { useSupportContact } from 'hooks/useSupportContact'

const HelpNumber = () => {
  const { phone, phoneDigits } = useSupportContact()

  if (!phoneDigits) return <Text>{phone}</Text>

  return (
    <Text a href={`tel:${phoneDigits}`}>
      {phone}
    </Text>
  )
}

HelpNumber.displayName = 'HelpNumber'

export default HelpNumber
